// AUTO-GENERATED by scripts/write-release.js — do not edit by hand.
// Carries the deployed git SHA so Sentry can map stack frames to a build.
export const APP_RELEASE: string = "406b2c887e1f7d7f2b3165b62493fac6f211a67f";
